import React from "react";
import { Link } from "react-router-dom";
import HamburgerBtn from "../../../../../atoms/button/HamburgerBtn";
import { MOBILE_LOGO_PROPS } from "../constants/mobileNavigation";

interface MobileMenuHeaderProps {
  logoProps?: { src?: string; alt?: string };
  isMenuOpen: boolean;
  onClose: () => void;
}

const MobileMenuHeader: React.FC<MobileMenuHeaderProps> = ({
  logoProps,
  isMenuOpen,
  onClose,
}) => {
  const src = logoProps?.src ?? MOBILE_LOGO_PROPS.src;
  const alt = logoProps?.alt ?? MOBILE_LOGO_PROPS.alt;

  return (
    <div className="flex items-center justify-between p-3">
      <div className="h-12 w-12">
        <Link to="/" className="cursor-pointer">
          <img src={src} alt={alt} className="h-12 w-auto object-contain" />
        </Link>
      </div>
      <HamburgerBtn isOpen={isMenuOpen} toggle={onClose} className="laptop:hidden" />
    </div>
  );
};

export default MobileMenuHeader;
